import { getToastTemplate, getVueToastTemplate } from "../../shortcodes/templates";

let toastShortcode = null;
const visualizeToast = content => {
  toastShortcode = content.querySelectorAll('[data-wrapper-id="toast-shortcode"]');

  if (toastShortcode.length > 0) {
    toastShortcode.forEach(item => {
      item.innerHTML = getToastTemplate();
    });
  }
};

const serializeToast = content => {
  const toastShortcodeWidget = content.querySelectorAll('[data-wrapper-id="toast-shortcode"]');
  if (toastShortcodeWidget.length > 0) {
    toastShortcodeWidget.forEach(item => {
      const toastData = item.getAttribute("data-toast-data");
      const initialTime = item.getAttribute("data-initial-time");
      item.innerHTML = getVueToastTemplate(toastData, initialTime);
    });
  }
};

export { visualizeToast, serializeToast };
